export default "__VITE_ASSET__963b279b__"